import { I18n } from "i18n-js";

export default ({ locale, locales }) => {
  const i18n = new I18n(locales);
  i18n.locale = locale;
  window.i18n = i18n;

  return i18n;
}
